import { AxiosResponse } from 'axios';
import environment from '@environment';
import { MakePaymentPayloadDTO, PaymentStatusDTO } from 'core/models/account/make-payment-payload.dto';
import { EndpointHelper } from 'core/services/endpoint.helper';
import { HttpClient } from 'core/services/http';
import { PaymentService } from 'core/stores/payment/interfaces/payment-service';
import { SiteConfigStore } from 'core/stores/site-config.store';

export interface PaymentRequestRedirectResponse {
  redirectUrl: string;
  transactionId: string;
  paymentType?: string;
  orderId?: string;
}

export class DPPaymentService implements PaymentService<MakePaymentPayloadDTO> {
  public canStatusPoll = true;
  public canRefetchPoll = false;
  public canTimeoutPoll = true;

  //apipaymentservice
  private paymentApiBuilder = new EndpointHelper(`${environment.DSTV_UTILITY_SERVICE}/uni-api/${environment.MAH_API_PAYMENT}/${environment.MAH_API_VERSION}`);

  MakePayment(req?: Partial<MakePaymentPayloadDTO>) {
    if (!req) {
      return Promise.reject('')
    }
    const url = this.paymentApiBuilder.createUrl('Payment')
      .addQueryParam('customerNumber', `${req.customerNumber}`)
      .addQueryParam('country', `${req.country}`)
      .build();
    // TODO: Add abort controller
    return HttpClient.GetInstance.post<Partial<MakePaymentPayloadDTO>, PaymentRequestRedirectResponse>(url, req).then(
      (res: AxiosResponse<PaymentRequestRedirectResponse>) => {
        const response = res?.data;
        return {
          redirectUrl: response.redirectUrl,
          transactionId: response.transactionId,
          paymentType: `${req.paymentType}`
        }
      }
    );
  }

  PaymentStatus(country: string, customerNumber: string, transactionId: string): Promise<PaymentStatusDTO> {
    const url = this.paymentApiBuilder
      .createUrl('Payment')
      .addQueryParam('country', country)
      .addQueryParam('customerNumber', customerNumber)
      .addQueryParam('TransactionId', transactionId)
      .addQueryParam('BusinessUnit', SiteConfigStore.businessUnit())
      .addQueryParam('Channel', SiteConfigStore.channel())
      .build();

    return HttpClient.GetInstance.get<PaymentStatusDTO>(url).then((res: AxiosResponse<PaymentStatusDTO>) => res.data);
  }

  RefetchPayment() {
    return Promise.reject('DPPaymentService -> RefetchPayment Not Implemented')
  }

  TokenLinks(req?: Partial<MakePaymentPayloadDTO>) {
    return Promise.reject(`DPPaymentService -> TokenLinks not implemented`);
  }
}